import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, SecondaryButton } from './ui/UI';
const integrations = ['AWS', 'Azure', 'Google Cloud', 'Microsoft 365', 'Entra ID', 'Google Workspace', 'Okta', 'GitHub', 'GitLab', 'Jira', 'Slack', 'ServiceNow', 'Cloudflare', 'Kubernetes', 'AI app endpoints', 'RAG systems', 'Agent toolchains'];
const categories = ['Cloud platforms', 'Identity providers', 'SaaS applications', 'Code repositories', 'AI applications', 'External domains', 'Internal networks', 'Ticketing systems', 'Security tools', 'Compliance workflows', 'MSSP reporting stacks'];
export function Integrations() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-577">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-578">
        <SectionLabel number="14" label="Integrations" className="mb-8" data-id="element-579" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-580">
          <div className="lg:col-span-7" data-id="element-581">
            <SectionHeading size="xl" data-id="element-582">
              Built to connect
              <br data-id="element-583" />
              <span className="text-white/40" data-id="element-584">where risk lives.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-585">
            <p className="text-lg text-white/60 leading-relaxed mb-4" data-id="element-586">
              Periscan is designed to validate across modern environments. Early
              access integrations will roll out in phases.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-587">
              {categories.slice(0, 5).map((c, i) => <span key={i} className="px-2.5 py-1 text-xs text-white/50 bg-white/[0.03] border border-white/5 rounded-md" data-id="element-588">
                  {c}
                </span>)}
            </div>
          </div>
        </div>

        {/* Integration grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/5 mb-12" data-id="element-589">
          {integrations.map((int, i) => <motion.div key={i} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.02
        }} className="bg-[#070a0e] h-24 flex items-center justify-center px-4 hover:bg-[#0a0d12] transition-colors group" data-id="element-590">
              <span className="text-sm text-white/60 group-hover:text-white transition-colors font-medium text-center" data-id="element-591">
                {int}
              </span>
            </motion.div>)}
        </div>

        <SecondaryButton href="#early-access" size="md" data-id="element-592">
          Request Integration Access
        </SecondaryButton>
      </div>
    </section>;
}